import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faHome } from '@fortawesome/pro-light-svg-icons'
import { faHome as faHomeSolid } from '@fortawesome/pro-solid-svg-icons'
import { TooltipModule } from 'primeng/tooltip'
import { MenuDrawerStateService } from '@app/navigation/services/menu-drawer-state.service'
import { ViewportService } from '@app/core/_services/viewport.service'

@Component({
    selector: 'fm-home-link',
    imports: [FaIconComponent, RouterModule, CommonModule, TooltipModule],
    templateUrl: './home-link.component.html',
    styleUrl: './home-link.component.scss',
})
export class HomeLinkComponent {
    public faHome = faHome
    public faHomeSolid = faHomeSolid
    public isHovered = false

    constructor(
        public menuDrawerStateService: MenuDrawerStateService,
        public viewportService: ViewportService,
    ) {}
    onMouseEnter() {
        if (!('ontouchstart' in window)) {
            this.isHovered = true
        }
    }

    onMouseLeave() {
        if (!('ontouchstart' in window)) {
            this.isHovered = false
        }
    }
}
